import { DeliveryProcessDefinition } from '@/api';
import { ENUM_StatusTypes } from '@/modules/configuration/common';

export const getDefinitionLabel = (definition: DeliveryProcessDefinition) => {
    let label = definition.label;
    if (definition.statusId != ENUM_StatusTypes.Actief.id) {
        const statusLabel = Object.values(ENUM_StatusTypes).find((x) => x.id == definition.statusId)?.name;
        label = `${definition.label} - ${statusLabel}`;
    }
    return label;
};
